<div class="cx-product-labels-container" *ngIf="labels && labels.length">
    <span *ngFor="let label of labels | slice: -2"
          [style.color]="label.fontColor"
          [style.background-color]="label.backgroundColor"
          [innerHtml]="label.text">
    </span>
</div>
